import React, { useEffect, useState } from "react";
import {
  Button,
  Divider,
  Grid,
  Typography,
  Autocomplete as Selectbox,
} from "@mui/material";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router";
import swal from "sweetalert";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import { IconArrowBack } from "@tabler/icons";
import {
  Autocomplete,
  GoogleMap,
  Marker,
  Circle,
} from "@react-google-maps/api";
import GeofencingSetupService from "src/service/geofenceSetup";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Update location Wise GeoFencing",
  },
];

const validationSchema = yup.object({
  location_name: yup
    .string("Enter Location name")
    .required("Location Name is required"),
  radius: yup
    .string("Enter Radius in km")
    .matches(/^[0-9.]{1,6}$/, "Invalid Radius")
    .required("Radius is Required"),
  alert_status: yup
    .string("Select Alert status")
    .required("Alert status is required"),
});

const UpdateLocationWiseFenceList = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const param = useParams();

  const [startingPlace, setStartingPlace] = useState({
    name: "",
    latitude: "",
    longitude: "",
  });

  const [startingPlaceMarker, setStartingPlaceMarker] = useState({
    position: { lat: 23.876536, lng: 85.876453 },
    address: "",
  });

  const [endMarker, setEndMarker] = useState({
    position: { lat: 23.876536, lng: 85.876453 },
    address: "",
  });

  const onAutocompleteLoadStart = (autocomplete) => {
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();

      if (place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        setStartingPlace((prevStartingPlace) => ({
          ...prevStartingPlace,
          place_name: place.formatted_address,
          latitude: lat,
          longitude: lng,
        }));

        setStartingPlaceMarker({
          position: { lat, lng },
          address: place.formatted_address,
        });
      }
    });
  };

  const calculateEndingCoordinates = (startLat, startLng, distance) => {
    const endingLat = startLat + distance / 111.32;
    const endingLng = startLng;

    return { lat: endingLat, lng: endingLng };
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const geofencingData =
          await GeofencingSetupService.get_location_wise_list({
            id: param.id,
            geo_fence_type: 1,
          });

        setStartingPlace({
          place_name: geofencingData.data[0].place_name,
          latitude: parseFloat(geofencingData.data[0].latitude),
          longitude: parseFloat(geofencingData.data[0].longitude),
          radius: geofencingData.data[0].radius / 1000,
          email_id: geofencingData.data[0].email_id,
          alert_status: parseInt(geofencingData.data[0].alert_status),
          location_name: geofencingData.data[0].location_name,
        });

        setStartingPlaceMarker({
          position: {
            lat: parseFloat(geofencingData.data[0].latitude),
            lng: parseFloat(geofencingData.data[0].longitude),
          },
          address: geofencingData.data[0].place_name,
          radius: geofencingData.data[0].radius / 1000,
        });
      } catch (error) {
        console.error("Error fetching geofencing data:", error);
        // Handle error, e.g., show an error message to the user
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialValues = {
    id: param.id,
    place_name: startingPlace.place_name,
    latitude: startingPlace.latitude,
    longitude: startingPlace.longitude,
    radius: startingPlace.radius,
    email_id: startingPlace.email_id || "",
    alert_status: startingPlace.alert_status,
    location_name: startingPlace.location_name,
    d_by: sessionData.data.id,
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        // alert(JSON.stringify(values, null, 2));

        try {
          const final_data = {
            id: param.id,
            place_name: startingPlace.place_name,
            latitude: startingPlace.latitude,
            longitude: startingPlace.longitude,
            radius: values.radius,
            alert_status: values.alert_status,
            email_id: values.email_id,
            location_name: values.location_name,
            d_by: sessionData.data.id,
          };

          const res = await GeofencingSetupService.update_geofencing_data(
            final_data
          );

          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/locationwisefencelist");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  const handleValuesChange = () => {
    if (startingPlace.latitude && startingPlace.longitude && values.radius) {
      const endingCoordinates = calculateEndingCoordinates(
        parseFloat(startingPlace.latitude),
        parseFloat(startingPlace.longitude),
        parseFloat(values.radius)
      );
      setEndMarker({
        position: endingCoordinates,
        address: `Geofencing Area (Radius: ${values.radius} km)`,
      });
    }
  };

  useEffect(() => {
    handleValuesChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startingPlace.latitude, startingPlace.longitude, values.radius]);

  return (
    <>
      <Breadcrumb title="Geo Fencing" items={BCrumb} />
      <ParentCard title="" style={{ minHeight: "600px !important" }}>
        <Grid container alignItems="center">
          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Update location Wise GeoFencing
            </Typography>
          </Grid>

          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/locationwisefencelist");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid item spacing={3} container lg={12} md={12} sm={12} xs={12}>
                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor="end_pt_latitude">
                    Start Place Name <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>

                  <Autocomplete onLoad={onAutocompleteLoadStart}>
                    <CustomTextField
                      type="text"
                      onChange={handleChange}
                      onBlur={(event, newValue) => {
                        handleBlur(event);
                      }}
                      variant="outlined"
                      placeholder="Enter starting address"
                      fullWidth
                      inputProps={{
                        defaultValue: startingPlace.place_name,
                      }}
                    />
                  </Autocomplete>
                </Grid>

                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor="latitude">
                    Latitude <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomTextField
                    type="text"
                    value={startingPlace.latitude}
                    variant="outlined"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </Grid>

                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor="start_pt_longitude">
                    Longitude <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomTextField
                    id="start_pt_longitude"
                    name="start_pt_longitude"
                    type="text"
                    value={startingPlace.longitude}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    variant="outlined"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </Grid>

                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor="radius">
                    Radius (Km) <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomTextField
                    id="radius"
                    name="radius"
                    type="text"
                    value={values.radius}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    variant="outlined"
                    placeholder="Enter Radius in Km"
                    fullWidth
                  />
                </Grid>

                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor="location_name">
                    Location Name <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomTextField
                    id="location_name"
                    name="location_name"
                    type="text"
                    value={values.location_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.location_name && Boolean(errors.location_name)
                    }
                    helperText={touched.location_name && errors.location_name}
                    variant="outlined"
                    placeholder="Enter Location name"
                    fullWidth
                  />
                </Grid>

                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor="email_id">
                    Email Id <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomTextField
                    id="email_id"
                    name="email_id"
                    type="text"
                    value={values.email_id}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.email_id && Boolean(errors.email_id)}
                    helperText={touched.email_id && errors.email_id}
                    variant="outlined"
                    placeholder="Enter Email id"
                    fullWidth
                  />
                </Grid>

                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor="alert_status">
                    Send Alert <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <Selectbox
                    id="alert_status"
                    name="alert_status"
                    options={[
                      { label: "Yes", value: 1 },
                      { label: "No", value: 2 },
                    ]}
                    getOptionLabel={(option) => option.label}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                    value={
                      [
                        { label: "Yes", value: 1 },
                        { label: "No", value: 2 },
                      ].find(
                        (option) => option.value === values.alert_status
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleChange({
                        target: {
                          name: "alert_status",
                          value: newValue?.value || "",
                        },
                      });
                    }}
                    onBlur={handleBlur}
                    renderInput={(params) => (
                      <CustomTextField
                        {...params}
                        error={
                          touched.alert_status && Boolean(errors.alert_status)
                        }
                        helperText={touched.alert_status && errors.alert_status}
                        fullWidth
                        variant="outlined"
                        placeholder="Select Yes or No"
                      />
                    )}
                  />
                </Grid>
              </Grid>

              <GoogleMap
                mapContainerStyle={{
                  height: "400px",
                  width: "100%",
                  marginTop: "20px",
                }}
                zoom={10}
                center={startingPlaceMarker.position}
              >
                <Marker position={startingPlaceMarker.position} />

                {endMarker.position && (
                  <Circle
                    center={startingPlaceMarker.position}
                    radius={parseFloat(values.radius) * 1000}
                    options={{
                      strokeColor: "#73A5C6",
                      strokeOpacity: 0.8,
                      strokeWeight: 2,
                      fillColor: "#73A5C6",
                      fillOpacity: 0.35,
                    }}
                  />
                )}
              </GoogleMap>
            </Grid>
            <Grid item lg={12} md={12} sm={12}>
              <Button type="submit" color="success" variant="contained">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </>
  );
};

export default UpdateLocationWiseFenceList;
